import React, { useState, useEffect } from 'react';
import './convocatorias.css';

const BYD = () => {
   
  const [expandida, setExpandida] = useState(null);
    
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleImagen = (id) => {
    setExpandida(expandida === id ? null : id);
  };

  return (
    <div
      className='container-full-width'
      style={{
        backgroundImage: `url('https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/DGSP2026.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}
    >
      <div className='row'>
        <div className='col-12'>

          <h3 
            className='title'
            style={{ 
              color: 'white',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Convocatoria
          </h3>

          <br />

           

          {/* IMAGEN 2 */}
          <div className="hero">
             <h5>Resumen</h5>
              <p></p>
            <div className="contenedor">
              <img
                src="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BMT_2026C.png"
                alt="BMT"
                className={expandida === 2 ? "img expandida" : "img"}
                onClick={() => toggleImagen(2)}
              />
            </div>
          </div>

          <br />

          <h5 
            className='hero'
            style={{ 
              color: 'white',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Consulta la convocatoria
          </h5>

          {/* BOTÓN PRINCIPAL */}
          <div className="botones">
            <a href="/documento/26" className="btn-vino">
              Descargar
            </a>
          </div>

          <br />

          <h5 
            className='hero'
            style={{ 
              color: 'white',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            En el siguiente enlace podrás realizar tu proceso, a partir de las 00:00 hrs del jueves 26 de marzo<br />y hasta las 23:59 hrs del viernes 27 de marzo de 2026:
          </h5>

          {/* BOTONES SECUNDARIOS */}
          <div className="botones">
            <a href="https://cuestionariosbienestar.hidalgo.gob.mx/2026-03/madres-trabajadoras" className="btn-vino">Registro</a>
          </div>

          <br />
           <h5 
            className='hero'
            style={{ 
              color: 'white',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
          Importante
          </h5>

          {/* IMAGEN 1 */}
          <div className="hero">
            <div className="contenedor">
              <img
                src="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BMT_2026D.png"
                alt="BMT"
                className={expandida === 1 ? "img expandida" : "img"}
                onClick={() => toggleImagen(1)}
              />
            </div>
          </div>

          <br />


         
          <hr className='hr-gob' />

        </div>
      </div>
    </div>
  );
};

export default BYD;